// extracted by mini-css-extract-plugin
export var bold = "_yr-0";